/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_System_Product_LockedInputs */

const vi_error_system_product_locked = /** @type {(inputs: Error_System_Product_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là sản phẩm hệ thống (dùng cho dòng KiotViet chưa nối), không sửa, xoá hay gán mã KiotViet được.`)
};

/**

* @param {Error_System_Product_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_system_product_locked = /** @type {((inputs?: Error_System_Product_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_System_Product_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_system_product_locked(inputs)
});